import React, { Component } from 'react'
import { injectIntl } from 'react-intl'
import { withRouter } from 'react-router'
import { connect } from 'react-redux'
import VideoView from '../assets-view/VideoView'
import SVGView from '../assets-view/SVGView'
import { unsetSelectExpandAsset, setSelectExpandAsset } from '../../actions/ClientAction'
import { Icon } from 'antd'
import { sendNotification } from '../../utils/index'
import { KEY_CODE_ESC, KEY_CODE_LEFT, KEY_CODE_RIGHT } from '../../utils'
import GoogleView from '../google-view/GoogleView'
import { getImageAssettByExtension } from '../../utils'
import fileextension from 'file-extension'
const parentStyle = {
  position: 'fixed',
  width: '100%',
  height: '100%',
  top: 0,
  left: 0,
  bottom: 0,
  right: 0,
  zIndex: 9,
  backgroundColor: '#000'
}

const assetStyle = {
  maxHeight: '100%',
  maxWidth: '100%',
  height: '80%',
  position: 'absolute',
  top: 0,
  bottom: 0,
  left: 0,
  right: 0,
  margin: 'auto'
}

const closeStyle = {
  position: 'absolute',
  fontSize: 25,
  top: 60,
  right: 18,
  cursor: 'pointer',
  color: '#000',
  backgroundColor: 'silver',
  padding: '0 10px',
  zIndex: 999,
  opacity: 0.5
}

const left = {
  position: 'absolute',
  fontSize: 25,
  top: '50%',
  left: 10,
  cursor: 'pointer',
  color: '#000',
  backgroundColor: 'silver',
  padding: '0 5px',
  zIndex: 999,
  opacity: 0.5
}

const right = {
  position: 'absolute',
  fontSize: 25,
  top: '50%',
  right: 10,
  cursor: 'pointer',
  color: '#000',
  backgroundColor: 'silver',
  padding: '0 5px',
  zIndex: 999,
  opacity: 0.5
}

export class CollectionItemFullScreen extends Component {

  constructor(props) {
    super(props)

    this.state = {
      isFetching: false,
      documentMediaUrl: null,
    }
  }

  isValidExtension = (itemExpandSelected) => {
    try {
      const formats = ['psd', 'cr2', 'nef', 'ai']
      const { originalURL } = itemExpandSelected
      const splittedUrl = originalURL.split(".")

      const extension = splittedUrl[splittedUrl.length - 1]

      return formats.includes(extension.toLowerCase())

    } catch (error) {

      return false
    }


  }
  componentDidMount() {
    const { itemExpandSelected } = this.props
    // if (itemExpandSelected && itemExpandSelected.originalURL.indexOf('.psd') > 0) {
    if (itemExpandSelected && this.isValidExtension(itemExpandSelected)) {
      if (itemExpandSelected.mediaQualityURL.indexOf('.jpg') > 0 || itemExpandSelected.mediaQualityURL.indexOf('.png') > 0) {
        this.setState({
          documentMediaUrl: true
        })
      }
      else {
        this.setState({
          documentMediaUrl: false
        })
      }
    } else {
      this.setState({
        documentMediaUrl: false
      })
    }
    window.scroll({ top: 0, left: 0, behavior: 'smooth' })
    document.addEventListener('keydown', this.handleOnKeyPress, false)

  }

  componentDidUpdate(prevProps) {
    const { itemExpandSelected } = this.props
    if (prevProps.itemExpandSelected !== itemExpandSelected) {
      // if (itemExpandSelected.originalURL.indexOf('.psd') > 0) {
      if (this.isValidExtension(itemExpandSelected)) {
        if (itemExpandSelected.mediaQualityURL.indexOf('.jpg') > 0 || itemExpandSelected.mediaQualityURL.indexOf('.png') > 0) {
          this.setState({
            documentMediaUrl: true,
            isFetching: false
          })
        } else {
          this.setState({
            documentMediaUrl: false,
            isFetching: false
          })
        }
      } else {
        this.setState({
          documentMediaUrl: false,
          isFetching: false
        })
      }
    }
  }

  handleOnKeyPress = (e) => {
    const { keyCollection, itemExpandSelected } = this.props
    if (e.keyCode === KEY_CODE_ESC) this.props.unsetSelectExpandAsset(keyCollection)
    if (e.keyCode === KEY_CODE_LEFT && itemExpandSelected.type !== 'video') this.handleOnPrev()
    if (e.keyCode === KEY_CODE_RIGHT && itemExpandSelected.type !== 'video') this.handleOnNext()
  }


  handleOnPrev = () => {
    const { keyCollection, intl } = this.props
    const prev = this.handlePrevNextItem('prev')
    if (prev) {
      this.setState({
        isFetching: true
      }, () => this.props.setSelectExpandAsset(keyCollection, prev))
    } else {
      sendNotification('info', intl, 'Estas viendo el primer registro')
    }
  }

  handleOnNext = () => {
    const { keyCollection, intl } = this.props
    const next = this.handlePrevNextItem('next')
    if (next) {
      this.setState({
        isFetching: true
      }, () => this.props.setSelectExpandAsset(keyCollection, next))
    } else {
      sendNotification('info', intl, 'Estas viendo el último registro')
    }
  }

  handlePrevNextItem = type => {
    const { data } = this.props
    const dataValid = data.filter(r => (r.type === 'image' || r.type === 'document'))
    let prev = -1
    let next = -1

    if (!dataValid || dataValid.length === 0) return

    dataValid.forEach((item, index) => {
      if (item.isExpandSelected) {
        prev = index - 1
        next = index + 1
      }
    })

    let futureItem = dataValid[type === 'prev' ? prev : next]
    if (!futureItem) {
      if (type === 'prev') {
        futureItem = dataValid.pop()
      } else {
        futureItem = dataValid[0]
      }
    }
    return futureItem
  }

  handleSetSrc = r => {
    const { originalURL, mediaQualityURL } = r;
    const itemUrl = (originalURL !== mediaQualityURL) ? mediaQualityURL : getImageAssettByExtension(r.originalURL);
    return itemUrl;
  }

  render() {

    const { itemExpandSelected, keyCollection } = this.props
    const { isFetching, documentMediaUrl } = this.state

    if (isFetching) {
      return (<div style={{ backgroundColor: '#ffffff' }}>loading</div>)
    }

    if (documentMediaUrl === null && itemExpandSelected.originalURL.indexOf('.psd') > 0) {
      return (<div style={{ backgroundColor: '#ffffff' }}>loading</div>)
    }

    return (
      <React.Fragment>
        {itemExpandSelected.type === 'video' &&
          <VideoView
            url={itemExpandSelected.mediaQualityURL}
            autoPlay={true}
            startFullScreen={true}
            onCloseFromFullScreen={() => this.props.unsetSelectExpandAsset(keyCollection)}
            disableDefaultControls={false}
            muted={false}
          />}
        {itemExpandSelected.type !== 'video' && <div style={parentStyle}>
          <div onClick={() => this.props.unsetSelectExpandAsset(keyCollection)} style={closeStyle}>
            &times;
          </div>
          <div onClick={this.handleOnNext} style={right}><Icon type="right" /></div>
          <div onClick={this.handleOnPrev} style={left}><Icon type="left" /></div>

          {itemExpandSelected.type === 'image' && fileextension(itemExpandSelected.originalURL) === 'svg'
            && <SVGView src={this.handleSetSrc(itemExpandSelected)} assetId={itemExpandSelected._id} />
          }
          {itemExpandSelected.type === 'image' && fileextension(itemExpandSelected.originalURL) !== 'svg' && <img
            style={assetStyle}
            src={this.handleSetSrc(itemExpandSelected)}
            alt='asset' />}
          {itemExpandSelected.type === 'document' && documentMediaUrl && <img
            style={assetStyle}
            src={itemExpandSelected.mediaQualityURL}
            alt='asset' />}
          {itemExpandSelected.type === 'document' && !documentMediaUrl && <GoogleView url={itemExpandSelected.originalURL} />}
        </div>}
      </React.Fragment>
    )
  }
}

const mapStateToProps = (state, ownProps) => {
  const { keyCollection } = ownProps
  let object

  switch (keyCollection) {
    case 'assetsRoot':
      object = {
        itemExpandSelected: state.assetsRoot.data.find(r => r.isExpandSelected),
        data: state.assetsRoot.data,
        error: state.assetsRoot.error,
      }
      break
    case 'assetsLastUploads':
      object = {
        itemExpandSelected: state.assetsLastUploads.data.find(r => r.isExpandSelected),
        data: state.assetsLastUploads.data,
        error: state.assetsLastUploads.error,
      }
      break
    case 'assetsShared':
      object = {
        itemExpandSelected: state.assetsShared.data.find(r => r.isExpandSelected),
        data: state.assetsShared.data,
        error: state.assetsShared.error,
      }
      break
    case 'assetsFavorites':
      object = {
        itemExpandSelected: state.assetsFavorites.data.find(r => r.isExpandSelected),
        data: state.assetsFavorites.data,
        error: state.assetsFavorites.error,
      }
      break
    case 'assetsExplore':
      object = {
        itemExpandSelected: state.assetsExplore.data.find(r => r.isExpandSelected),
        data: state.assetsExplore.data,
        error: state.assetsExplore.error,
      }
      break
    case 'searcher':
      object = {
        itemExpandSelected: state.searcher.data.find(r => r.isExpandSelected),
        data: state.searcher.data,
        error: state.searcher.error,
      }
      break
    case 'assetsPublicShared':
      object = {
        itemExpandSelected: state.assetsPublicShared.data.find(r => r.isExpandSelected),
        data: state.assetsPublicShared.data,
        error: state.assetsPublicShared.error,
      }
      break

    default:
      object = {}
      break
  }
  return {
    ...object,
    verticalCount: state.app.verticalCount,
    horizontalCount: state.app.horizontalCount,
    workclient: state.client.workclient
  }
}

const mapDispatchToProps = {
  unsetSelectExpandAsset,
  setSelectExpandAsset
}

export default injectIntl(withRouter(connect(mapStateToProps, mapDispatchToProps)(CollectionItemFullScreen)))
